export enum ServiceTypeEnum {
    REQUEST = "R",
    FUNCTIONALITY = "F",
}

export enum ServiceFunctionalityEnum {
    SYNC_WALLET = "#SYNCWALLET",
}
